import React from "react";
import styles from "./Privacy.module.css";
import img from "../../Images/Tiwi-log.png";

const PrivacyPolicy = () => {
  return (
    <>
      <div className={styles.container}>
        <a
          href="https://tiwil.app"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logoo}
        >
          <img src={img} alt="tiwil Logo" />
        </a>
        <h1 className={styles.heading}>Privacy Policy</h1>
        <p className={styles.updated}>Last updated: Jul 21, 2025</p>

        <div className={styles.contentdiv}>
          <section>
            <h2>Introduction to Tiwil Privacy Policy</h2>
            <p>
              This Privacy Policy explains how <strong>Tiwil</strong> ("we",
              "our", or "us") collects, uses, stores, and protects personal
              information in connection with the{" "}
              <strong>Tiwil Event & Wishlist Application</strong>.
            </p>
            <p>
              It applies to all individuals who use Tiwil, including Event
              Organizers and Guests/Participants.
            </p>
          </section>

          <section>
            <h4>Who We Are (Tiwil)</h4>
            <p>
              Tiwil is a personal event and wishlist management app that helps
              you:
            </p>
            <ul>
              <li>Organize events (birthdays, weddings, holidays, etc.)</li>
              <li>Create and share wishlists</li>
              <li>Invite friends and family</li>
              <li>Track purchases and avoid duplicate gifts</li>
              <li>Enable group gifting</li>
              <li>Share personal preferences with loved ones</li>
            </ul>
          </section>

          <section>
            <h4>Information We Collect</h4>
            <ul>
              <li>
                <strong>Event Information:</strong> Event name, date, guest list
              </li>
              <li>
                <strong>Wishlist Data:</strong> Items, group contributions,
                purchases
              </li>
              <li>
                <strong>User Account Data:</strong> Name, email, phone number
              </li>
              <li>
                <strong>Guest Data:</strong> Invitee names, RSVP status
              </li>
              <li>
                <strong>Device Data:</strong> IP, browser type, app usage
              </li>
            </ul>
          </section>

          <section>
            <h4>How We Use Your Information</h4>
            <ul>
              <li>To provide and maintain the app</li>
              <li>To send invitations, reminders, notifications</li>
              <li>To prevent duplicate purchases</li>
              <li>To improve app experience with analytics</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h4>Sharing of Information</h4>
            <p>
              We do <strong>not</strong> sell your data. We may share
              information:
            </p>
            <ul>
              <li>With invited guests (event details, wishlist)</li>
              <li>With third-party providers (hosting, SMS, payments)</li>
              <li>As required by law</li>
            </ul>
          </section>

          <section>
            <h3>Contact Us</h3>
            <p>
              If you have questions, contact us at:{" "}
              <a href="info@tiwil.com">info@tiwil.com</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
